export default () => {

    let form = document.querySelector('.wpcf7');
    let downloadsLinks = document.querySelectorAll('.downloads__link');

    if (form) {
        form.addEventListener('wpcf7mailsent', function (event) {
            downloadsLinks.forEach((item) => {
                item.classList.remove('downloads__link--blocked');
            })
        }, false);
    }
}
